import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable()
export class RouteChangeService {
  constructor(
    private router: Router
  ) {}

  // Makes sure each route change scrolls to top of window
  scrollToTop() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd)
        window.scrollTo(0, 0);
    });
  }
}
